import type { Activity, ActivityType } from "@/core/types";
import { patientRequestsTyped } from "@/APIRequests/patientTyped";

const params = { showLoader: false };

export async function getActivityList({ type }: { type: ActivityType }): Promise<Activity[]> {
  return patientRequestsTyped.get_activity_list({ params, type });
}
